module.exports = __webpack_public_path__ + "img/tt7.ba84b170.png";